export const FIELD_TEMPLATE = {
  ratingStars: 0,
  ratingColors: 1,
  singleSelectRadio: 2,
  singleSelectColors: 3,
  ratingColorsGrayscale: 4,
  ratingColorsColorful: 5,
  singleSelectColorsful: 6
}
